import React, { Component } from "react";
import { inject, observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';
import _ from "lodash";
import validate from 'validate.js';

import { PageWrapper } from "components/PageWrapper";
import QuestionForm from "../components/QuestionForm";

import {QUESTION_CONSTRAINS} from 'constants/adminPupups';
import HttpClient from 'services/HttpClient';

const MCQ_QUESTIONS_API = '/api/v1/mcq_questions';
const MCQ_THEMES_API = '/api/v1/themes';

@withRouter
@inject('mcqThemesStore')
@inject('mcqQuestionsStore')
@inject('alertStore')
@observer
class AddQuestion extends Component {
  componentDidMount() {
    const { mcqQuestionsStore, mcqThemesStore } = this.props;

    mcqQuestionsStore.clearQuestion();

    new HttpClient().get(MCQ_THEMES_API)
    .then(({ body }) => {
      mcqThemesStore.setMcqThemes(body.data.theme);
    });
  };

  validationProcess = question => {
    let errors = validate(question, QUESTION_CONSTRAINS, { fullMessages: false });

    return errors
  };

  onSubmit = () => {
    const {mcqQuestionsStore, alertStore, history, mcqThemesStore: { mcq_themes }} = this.props;
    const ids = mcq_themes.map(theme => theme.id);
    const theme_ids = mcqQuestionsStore.question.theme_ids;
    const question = _.assign({}, mcqQuestionsStore.question, {
      theme_ids: theme_ids.length === 0 ? ids : theme_ids,
    });
    const errors = this.validationProcess(question);

    if (errors) return;

    new HttpClient().post(MCQ_QUESTIONS_API, {mcq_question: question})
    .then(data => {
      alertStore.success('You successfully create question');
      history.push('/mcq-questions');
    });
  };

  render() {
    return (
      <PageWrapper>
        <div className="page-container">
          <h2>Add MCQ Question</h2>
        </div>
        <div className="row">
          <div className="container">
            <QuestionForm />
            <div className="submit-btns-container">
              <Link className='btn-new-main' to='/mcq-questions'>cancel</Link>
              <button className='btn-new-main' onClick={this.onSubmit}>create question</button>
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
};

export default AddQuestion;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqQuestions/containers/AddQuestion.js